import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SITE_NAME, SITE_URL, getPageSeo } from '../data/seo';

function Seo({
  title,
  description,
  keywords,
  path,
  image,
  noIndex = false,
  schema,
}) {
  const { pathname } = useLocation();
  const pagePath = path || pathname || '/';
  const defaults = getPageSeo(pagePath);
  const seoTitle = title || defaults.title;
  const seoDescription = description || defaults.description;
  const seoKeywords = keywords || defaults.keywords;
  const canonical = `${SITE_URL}${pagePath === '/' ? '/' : pagePath.replace(/\/$/, '')}`;
  const ogImage = image || `${SITE_URL}/favicon.png`;
  const robots = noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large';
  const schemas = Array.isArray(schema) ? schema.filter(Boolean) : schema ? [schema] : [];

  return (
    <Helmet>
      <html lang="en" />
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content={SITE_NAME} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="theme-color" content="#0B2A5B" />
      <meta name="geo.region" content="IN-DL" />
      <meta name="geo.placename" content="New Delhi" />

      {schemas.map((item, index) => (
        <script key={item['@type'] || index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export default Seo;
